export default __webpack_public_path__ + "static/media/apr2023-5.f8f5369f.jpg";